export default "__VITE_ASSET__DWnloBb4__"